// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.td_underline[data-v-9618393a] {cursor: pointer; color: #000 !important;}\n.badge[data-v-9618393a] {\n  background-color: #4B5EFC; /* 이미지의 보라색 계열 */\n  color: white;\n  padding: 4px 8px;\n  border-radius: 6px;\n  font-size: 9px;\n  font-weight: 700;\n  line-height: 1;\n}\n", ""]);
// Exports
module.exports = exports;
